import React, { useState } from "react";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { t } from "i18next";
import CoreAutoComplete from "../../../app/core/components/CoreAutoComplete/CoreAutoComplete";
import CoreCalendar from "../../../app/core/components/CoreCalendar/CoreCalendar";
import { useGetCitiesQuery } from "../../api/user/modificaProfiloApi";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";

const Reservation = () => {
  const orariDisponibili = [
    { time: "09:00/10:00", value: "A" },
    { time: "11:00/12:00", value: "B" },
    { time: "12:00/13:00", value: "C" },
    { time: "16:00/17:00", value: "D" },
    { time: "17:00/18:00", value: "E" },
    { time: "18:00/19:00", value: "F" },
  ];

  const [formData, setFormData] = useState({});

  const [singleEvent, setSingleEvent] = useState();

  const handleInputChangeAuto = async (event, newValue) => {
    setFormData((prevData) => ({
      ...prevData,
      common: {
        name: newValue?.name,
        cadastralCode: newValue?.cadastralCode,
        province: newValue?.province,
      },
    }));
  };

  const handleOpen = (el) => {
    setSingleEvent(el);
  };

  return (
    <div>
      <h2 className="text-center">{t("CreateReservation")} </h2>

      <div className="flex space-x-10 p-4 justify-center">
        <div className="w-1/2">
          <h3 className="text-center">Seleziona una sede zonale </h3>

          <div className="flex flex-col">
            <CoreAutoComplete
              name="common"
              common={formData?.common?.name}
              label={t("City")}
              onChange={handleInputChangeAuto}
              fetchData={useGetCitiesQuery}
            />
          </div>

          <div className="py-4">
            <h3 className="text-center">Seleziona una data disponibile</h3>

            <CoreCalendar onCreate={handleOpen} />
          </div>

          <div className="py-4">
            <h3 className="text-center">Seleziona orario disponibile</h3>

            <div className="w-full grid grid-cols-3 gap-2">
              {orariDisponibili.map((el, index) => (
                <div key={index} className="flex justify-center">
                  <CoreChip
                    variant="outlined"
                    onClick={() => console.log(el.value)}
                    label={el.time}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full justify-around mt-10">
        <CoreButton
          className="bg-red-700 btn-round border-red-700"
          variant="contained"
          testo={t("Delete")}
          // onClick={handleDeleteService}
          // disabled={isLoadingDelete || isLoadingEdit}
        />

        <CoreButton
          className={"btn-round"}
          variant="contained"
          testo={t("Save")}
          //   onClick={handleSave}
          //   disabled={isLoadingCreate || isLoadingEdit}
        />
      </div>
    </div>
  );
};

export default Reservation;
